
<template>
	<div ref="listWrap">
		<wrapper-list 
        @calculate="paasCalculate"      
		ref="wrapperList" >
      	<Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
          <row class="list-query-row">
            <FormItem label="推广人:" class="list-query-item">
              <Input  v-model="queryParam.query_LIKE_spreadName"
                      @on-change="queryTableDatas('param')" />
            </FormItem>
            <FormItem label="订单号:" class="list-query-item">
                  <Input  v-model="queryParam.query_LIKE_orderId"
                          @on-change="queryTableDatas('param')" />
            </FormItem>
              <FormItem label="买家昵称:" class="list-query-item">
                  <Input  v-model="queryParam.query_LIKE_nickname"
                          @on-change="queryTableDatas('param')" />
              </FormItem>
          </row>
        </Form>
      	<Table slot="table" stripe border :height="tableHeight"
             :data="tableData"
             :columns="tableColumns"
             @on-selection-change="selectTableDataChange"
             @on-sort-change="sortTableData"
             :no-data-text="noDataText">
        </Table>
        <Page slot="page"  :total="totalRecords"
            show-total show-sizer
            @on-change="changePage"
            @on-page-size-change="changePageSize">
        </Page>
        </wrapper-list>
   </div>
</template>
<script>
	import wrapperList from "@components/paas/wrapper-list";
    import metaList from "@assets/js/list/meta-list.js";
    import EnumShow from "@/components/paas/enum-show";  //如果有枚举，需要引入
    import CellBar from '@components/paas/cell-bar' //列表内操作

    export default {
      name: "list",
      mixins: [ metaList ],
      components: { wrapperList,EnumShow  ,CellBar},
      data() {
      	return {
      		serviceUrl:"/member/commission/record",  //每个页面访问后台服务器的路径
      		currentIdFiledName: 'id',
      		queryParam:{
                query_LIKE_spreadName:'',
                query_LIKE_orderId:"",
                query_LIKE_nickname:"",
                queryOrderBy_: 'createTime@DESC;timeOrder@desc',
	        },
	        defaultLabelWidth:200,
	         tableColumns:[
                {
                     title: '推广人昵称',
                     key: 'spreadName',
                },
	        	{
	        		title: '订单号',
	        		key: 'orderId',
	        	},
                {
                     title: '买家昵称',
                     key: 'nickname',
                },
	        	{
	        		title: '商品名称',
	        		key: 'storeName',
	        	},
                 {
                   title: '成交价',
                   key: 'transPrice',
                 },
                 {
                   title: '佣金比',
                   key: 'commisionRatio',
                 },
	        	{
	        		title: '佣金金额',
	        		key: 'commissionPrice',
	        	},
                 {
                     title: '返佣时间',
                     key: 'createTime',
                 }
	        ],
      	}
      },
      mounted(){
      },
      methods:{
      }
    } 
</script>
